export const KICK_REPORT_TEMPLATE_NAME = "Kick";

export const KICK_REPORT_TEMPLATE_DESCRIPTION = "Kick standard report template";
export const KICK_REPORT_TEMPLATE_FILTER_VALUE = "kick";

export const REPORT_SETTINGS_TEMPLATE_NAME_MAX_LENGTH = 255;

export const REPORT_SETTINGS_TEMPLATE_DESCRIPTION_MAX_LENGTH = 1000;
